import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const BUYERS = [{
  name: 'Carlos',
  city: 'Buenos Aires'
}, {
  name: 'María',
  city: 'Córdoba'
}, {
  name: 'Diego',
  city: 'Rosario'
}, {
  name: 'Laura',
  city: 'Mendoza'
}, {
  name: 'Sebastián',
  city: 'Montevideo'
}, {
  name: 'Valentina',
  city: 'Santiago'
}, {
  name: 'Matías',
  city: 'Lima'
}];
export function PurchasePopup() {
  const [currentBuyer, setCurrentBuyer] = useState<(typeof BUYERS)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showBuyer = () => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5s
    };
    // Initial delay
    const initialTimeout = setTimeout(showBuyer, 15000);
    // Loop
    const interval = setInterval(showBuyer, 25000); // Show every 25s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-293">
      {isVisible && currentBuyer && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} className="fixed bottom-4 left-4 z-50 bg-zinc-900 border-l-4 border-yellow-500 rounded-r-lg shadow-2xl p-4 max-w-xs flex items-center gap-3" data-id="element-294">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-yellow-500 flex items-center justify-center text-black font-bold text-lg" data-id="element-295">
            {currentBuyer.name[0]}
          </div>
          <div data-id="element-296">
            <p className="text-white text-sm font-bold" data-id="element-297">
              {currentBuyer.name}{' '}
              <span className="text-zinc-400 font-normal" data-id="element-298">
                acaba de comprar
              </span>
            </p>
            <p className="text-xs text-zinc-500 flex items-center gap-1" data-id="element-299">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-300"></span>
              {currentBuyer.city} • Hace unos segundos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}